import { Typography } from "@mui/material";

// Interface para o item retornado pela API
export interface BuscaProdutoItem {
	productId: string;
	imageId: string;
	path: string;
	score: number;
}

// Componente do Carrossel
const ImageCarousel: React.FC<{ images: BuscaProdutoItem[] }> = ({ images }) => {
	return (
		<div style={{
			display: 'flex',
			overflowX: 'auto',
			padding: '20px 0',
			gap: '20px'
		}}>
			{images.map((item) => (
				<div key={item.productId} style={{
					minWidth: '200px',
					borderRadius: '10px',
					boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
					overflow: 'hidden',
					padding: '10px',
				}}>
					<img
						src={`${window._env_.API_URL}/api/varejo/produto/${item.productId}/imagem/${item.imageId}`}
						alt={`Image ${item.productId}`}
						style={{
							width: '100%',
							height: '200px',
							objectFit: 'cover'
						}}
					/>
					<Typography variant="h6"><b>{item.productId}</b></Typography>
					<Typography variant="body1">Similaridade: {(item.score * 100).toFixed(0)}%</Typography>
				</div>
			))}
		</div>
	);
};

export default ImageCarousel;